import React from 'react'
import yid  from '../images/store.png'
export default function Address() {
    return (
        <div id ='about2'>
            <div className ='about-text'>

            <h1> St-catherine 184X </h1>
            <p> 514-848-2424 </p>

            
            </div>
            <div className='about-image'>
                <img src={yid} alt=''/>
            </div>
            
        </div>
    )
}
